import { Dispatch, SetStateAction } from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { getFullDate } from 'utils/helpers';
import { TELEMATICS_MAX_DAYS } from 'utils/constants';

interface DateRangeProps {
	startDate: string;
	endDate: string;
	setStartDateValue: Dispatch<SetStateAction<string>>;
	setEndDateValue: Dispatch<SetStateAction<string>>;
	containerStyles?: CSSProperties;
	width?: string;
}

const DateRangePicker = ({
	startDate,
	endDate,
	setStartDateValue,
	setEndDateValue,
	containerStyles,
	width = '200px',
}: DateRangeProps) => {
	const getMaxEndDate = (dd = startDate, maxDays = TELEMATICS_MAX_DAYS) => {
		const date = new Date(dd);
		const res = date.setTime(
			date.getTime() + maxDays * 24 * 60 * 60 * 1000,
		);
		const newDate = new Date(res);
		return getFullDate(newDate);
	};

	return (
		<Box sx={containerStyles}>
			<TextField
				fullWidth
				size="small"
				label="Start Date"
				sx={{
					marginTop: '20px',
					marginRight: '20px',
					background: 'white',
					width: width,
				}}
				type="date"
				name="startDate"
				value={startDate}
				onChange={(event: any) => {
					setStartDateValue(event.target.value);
					setEndDateValue(getMaxEndDate(event.target.value, 2));
				}}
			/>
			<TextField
				disabled={!startDate}
				label="End Date"
				inputProps={{
					min: startDate || '',
					max: getMaxEndDate(),
				}}
				size="small"
				sx={{ marginTop: '20px', background: 'white', width: width }}
				type="date"
				name="endDate"
				value={endDate}
				onChange={(event: any) => setEndDateValue(event.target.value)}
			/>
		</Box>
	);
};

export default DateRangePicker;
